function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "480px",
    height: "480px",
    viewBox: "0 0 480 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(32.54902%,75.686275%,87.058824%)",
      fillOpacity: 1
    },
    d: "M 240 197.039062 C 216.28125 197.039062 197.058594 216.261719 197.058594 239.980469 C 197.058594 263.699219 216.28125 282.921875 240 282.921875 C 263.71875 282.921875 282.941406 263.699219 282.941406 239.980469 C 282.941406 216.261719 263.71875 197.039062 240 197.039062 Z M 240 197.039062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 240 342.859375 C 123.660156 342.859375 0 306.800781 0 240 C 0 173.199219 123.660156 137.140625 240 137.140625 C 356.339844 137.140625 480 173.199219 480 240 C 480 306.800781 356.339844 342.859375 240 342.859375 Z M 240 167.140625 C 119.800781 167.140625 30 205.601562 30 240 C 30 274.398438 119.800781 312.859375 240 312.859375 C 360.199219 312.859375 450 274.398438 450 240 C 450 205.601562 360.199219 167.140625 240 167.140625 Z M 240 167.140625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 155.480469 459.960938 C 145.058594 459.960938 135.519531 457.398438 127.339844 452.300781 C 70.578125 417.058594 102.699219 288.738281 161.71875 185.921875 C 211.480469 99.199219 276.039062 35 326.179688 22.359375 C 343.640625 17.941406 359.558594 19.800781 372.238281 27.699219 C 429 62.941406 396.878906 191.261719 337.859375 294.078125 C 288.121094 380.800781 223.558594 444.980469 173.398438 457.640625 C 167.199219 459.199219 161.199219 459.960938 155.480469 459.960938 Z M 344.121094 50 C 340.878906 50 337.339844 50.480469 333.5 51.460938 C 298.558594 60.261719 239.921875 109.859375 187.71875 200.839844 C 126.300781 307.878906 113.539062 408.441406 143.140625 426.839844 C 148.820312 430.378906 156.519531 430.960938 166.039062 428.539062 C 201 419.738281 259.621094 370.121094 311.820312 279.160156 C 373.261719 172.121094 386.019531 71.558594 356.398438 53.160156 C 353 51.058594 348.898438 50 344.121094 50 Z M 344.121094 50 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 324.519531 459.960938 C 318.800781 459.960938 312.800781 459.199219 306.601562 457.640625 C 256.441406 444.980469 191.878906 380.800781 142.140625 294.078125 C 83.121094 191.238281 51 62.921875 107.78125 27.699219 C 120.421875 19.800781 136.359375 17.941406 153.820312 22.359375 C 203.960938 35 268.519531 99.199219 318.28125 185.921875 C 377.300781 288.761719 409.421875 417.078125 352.660156 452.300781 C 344.480469 457.398438 334.960938 459.960938 324.519531 459.960938 Z M 135.878906 50 C 131.101562 50 127 51.058594 123.601562 53.160156 C 93.960938 71.558594 106.71875 172.121094 168.160156 279.160156 C 220.359375 370.121094 279 419.71875 313.941406 428.539062 C 323.480469 430.960938 331.140625 430.378906 336.839844 426.839844 C 366.460938 408.441406 353.699219 307.878906 292.261719 200.839844 C 240.058594 109.859375 181.421875 60.28125 146.480469 51.460938 C 142.660156 50.480469 139.121094 50 135.878906 50 Z M 135.878906 50 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 240 290 C 212.441406 290 190 267.578125 190 240 C 190 212.421875 212.441406 190 240 190 C 267.558594 190 290 212.421875 290 240 C 290 267.578125 267.558594 290 240 290 Z M 240 220 C 228.980469 220 220 228.960938 220 240 C 220 251.039062 228.980469 260 240 260 C 251.019531 260 260 251.039062 260 240 C 260 228.960938 251.019531 220 240 220 Z M 240 220 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReact);
export default __webpack_public_path__ + "static/media/react.f643c1da3df8d2f117502c8115910198.svg";
export { ForwardRef as ReactComponent };